export default "__VITE_ASSET__CR6TkMDu__"